import { GoogleAnalyticsEvent, GoogleAnalyticsEvents, reportEvent } from "../hooks/useGoogleTagManager";

export default class GtmService {
    reportEvent = (eventProvider: (builder: GoogleAnalyticsEvents) => GoogleAnalyticsEvent) => {
        // pass call to our hook
        reportEvent(eventProvider);
    };
}
